import { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { documentShow } from '../../features/dashboard/DocumentSlice'
import { uploadImage } from '../../features/dashboard/DocumentRequestSlice';
import { documentAttachments } from '../../features/dashboard/DocumentTransferSlice'
import Loading from '../../Loading';
import Header from './Header';
import Input from '../../component/form/Input';
import Select from '../../component/form/Select';
import Button from '../../component/form/Button';
import { ToastContainer, toast } from 'react-toastify';
import {host} from '../../function/api'

function DocumentTransferUploadFile () {
    const data = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const sanadno = useRef()
    const [image, setImage] = useState('')
    const [uploadType, setUploadType] = useState('')
    let { 
        loading, 
        success, 
        message,
        status,
        error,
        errorFile,
        errorUploadType
    } = useSelector((state) => state.documentRequest)
    let { document } = useSelector((state) => state.document)
    let { attachments } = useSelector((state) => state.documentTransfer)
    const token = localStorage.getItem('token')
    
    function fileHandler(e) {
        setImage(e.target.files[0])
    } 

    function handleApi(e) {
        const formData = new FormData()
        formData.append('file', image)
        formData.append('transfer_id', data.transfer)
        formData.append('uploadType', uploadType)
        dispatch(uploadImage(formData))    
    }

    const handlePrevious = () => {
        navigate(`/dashboard/document/transfers/${data.document}`)
    }

    const transferFilesHandler = () => {
        const transfer_id = {
            'transfer_id': data.transfer
        }
        dispatch(documentAttachments(transfer_id))
    }

    useEffect ( () => {
        attachments = ['']
        dispatch(documentShow(data.document))
        if(loading === false && success === true) {            
            toast.success(message,{
                position: "top-center",
                autoClose: 1200,
              })
            message = ''
        }
    },[data,loading])

    return (
        <>
            { loading === true ? <Loading /> : null }
            <div className='row g-2 p-5 pb-4 my-5'>
                <div className='d-flex justify-content-between'>
                    <Header title='بارگذاری مدارک سند' />
                    <p className='px-4 pt-2 fs-4 fw-bold'>
                        {document.mt_sanadno ? document.mt_sanadno : null}
                    </p>
                </div>
                <div className="col-12">
                    <div className="row m-3">
                        <label 
                            htmlFor="staticEmail" 
                            className="text-end fw-bold form-label px-1">
                            کدام مدرک را بارگذاری میکنید
                        </label>
                        <select 
                            style={{marginBottom: '2px'}}
                            value={uploadType}
                            defaultValue={'DEFAULT'}
                            tabIndex="1"
                            onChange={(e) => setUploadType(e.target.value)}
                            className="form-control form-select form-select-lg shadow-none" 
                            aria-label="form-select-lg example">
                            <option value='DEFAULT' selected>یک مورد را انتخاب کنید</option>
                            <option value='personal'>مدارک شناسایی</option>
                            <option value='owner'>مدارک مالکیت</option>
                        </select>
                        {
                            (errorUploadType) ? (
                            <span className="help-block fw-bold d-inline-block mt-2">
                                <small className='text-danger validate-error'>
                                    { errorUploadType }
                                </small>
                            </span>
                        ):''}
                    </div>
                </div>
                <div className="col-12">
                    <div className='row m-3 py-5 border border-3'>
                        <label htmlFor="formFile" className="form-label fw-bold text-end px-1 text-center">یک فایل با پسوند jpg , png , jpeg انتخاب کنید</label>
                        <input className="form-control form-control-lg invisible d-none" type='file' name='file' onChange={fileHandler} id="formFile" />
                        {
                            errorFile ? (
                                <span className="help-block fw-bold d-inline-block mt-2">
                                    <small className='text-danger validate-error'>
                                        { errorFile }
                                    </small>
                                </span>
                            ) : null
                        }
                    </div>                  
                </div>
                <a className='btn text-muted fw-bold px-3' onClick={transferFilesHandler}>
                    مشاهده مدارک این سند
                </a>
            </div>
            {
                Object.keys(attachments).length > 0 ? (
                    <div className='row g-2 p-5 pb-4 my-5'>
                        {
                            attachments.map((attachment) => (
                                <div className='col-6 col-md-3'>
                                    <img
                                        className='img-fluid' 
                                        src={`http://localhost/document-backend/public/${attachment.path}${attachment.file}`} 
                                    />
                                </div>
                            ))
                        }
                    </div>
                ) : null
            }
            <div className="col-12 my-4 px-0 d-flex justify-content-end">
                <Button 
                    tab='15'
                    title=' مدیریت انتقال سند '
                    design="px-4 py-1 mx-3 btn btn-dark fw-bold"
                    event={handlePrevious}
                />
                <Button 
                    tab='14'
                    title=' بارگذاری مدارک '
                    design="px-4 py-1 btn btn-dark fw-bold"
                    event={handleApi}
                />
            </div>
        </>
    ) 
}

export default DocumentTransferUploadFile;